import './GenerateQuestionPrompt.scss';

import * as React from 'react';

import { useAtom } from 'jotai';

import { FeatureUseEventAdapter } from '~analytics/adapters/FeatureUseEventAdapter';
import { translate } from '~l10n/client';
import { Link } from '~shared/components/Link';
import Textarea from '~shared/components/Textarea/Textarea';
import { promptAtom } from '~teacher/components/QuizEditor/GenerateQuestionDialog/atom';

//TODO replace this with the actual URL when the article is finished.
const LEARN_MORE_PROMPT_URL =
  'https://help.socrative.com/en/articles/8732134-socrative-ai-question-generation#h_20a75b424f';

const MAX_PROMPT_LENGTH = 3000;

interface Props {
  suffix?: React.ReactNode;
}

export const GenerateQuestionPrompt = React.forwardRef(
  function GenerateQuestionPrompt(
    { suffix }: Props,
    ref: React.Ref<HTMLTextAreaElement>
  ) {
    const [prompt, setPrompt] = useAtom(promptAtom);
    const promptLength = prompt.length;

    return (
      <div className="grid auto-rows-min gap-2 generate-question-prompt-grid">
        <div className="flex flex-row gap-2">
          <label
            className="flex-grow text-base text-sans text-blue-900 leading-8"
            htmlFor="prompt"
          >
            {translate('Describe what you want the questions to cover')}
          </label>
          <div className="flex flex-shrink justify-end">
            {promptLength} / {MAX_PROMPT_LENGTH}
          </div>
        </div>
        <Textarea
          aria-describedby="prompt-description"
          id="prompt"
          ref={ref}
          maxLength={MAX_PROMPT_LENGTH}
          className="flex-grow row-start-2"
          placeholder={translate(
            'e.g., The solar system and natural satellites'
          )}
          maxRows={7}
          value={prompt}
          onChange={(event) => setPrompt(event.target.value)}
        />
        <div className="flex flex-shrink row-start-2 col-start-2">{suffix}</div>
        <div
          id="prompt-description"
          className="font-sans text-xs text-blue-600 items-start col-span-2 row-start-3"
        >
          {translate(
            'Consider using details like topic, standard, learning objective, example questions, and excerpts to increase question quality.'
          )}{' '}
          <Link
            href={LEARN_MORE_PROMPT_URL}
            target="_blank"
            rel="noopener noreferrer"
            includeCommonStyles
            className="font-800 text-cyan-700 hocus:text-cyan-600"
            onClick={() => {
              new FeatureUseEventAdapter({
                feature: 'prompt_learn_more_link',
                source: 'generate_questions_step_1',
                action: 'click',
              }).sendAnalytics();
            }}
          >
            {translate('Learn More')}
          </Link>
        </div>
      </div>
    );
  }
);
